import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/net-effective-rent',
  component: () => import('../../routes/NetEffectiveRentCalculator.svelte'),
  card: {
    id: 'net-effective-rent',
    title: 'Net Effective Rent',
    description: 'Compare commercial leases by calculating the true annualized rent after concessions.',
    icon: 'real_estate_agent',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/net-effective-rent',
    category: 'Real Estate',
  },
  seo: {
    title: 'Net Effective Rent Calculator – Commercial Lease Analyzer',
    description:
      'Calculate the true cost of a commercial lease by accounting for free rent, TI allowances, and rent escalations. Compare leases fairly.',
  },
};

export default meta;
